import type {FinancialProductType} from '../schemas/FinancialProductTypeSchema';
import {getConfiguredFinancialProducts} from './getConfiguredFinancialProducts';

/** A selected product remains primary even when its slot is missing or unavailable. */
export const getPrimaryFinancialProductType = (
  products: Parameters<typeof getConfiguredFinancialProducts>[0] & {
    readonly selectedProduct: FinancialProductType | null;
  },
  productOrder: readonly FinancialProductType[]
) => products.selectedProduct ?? getConfiguredFinancialProducts(products, productOrder).at(0);
